module.exports = __webpack_public_path__ + "img/slika18.02142890.jpg";